import React, { useState, useEffect } from 'react';
import AuthHero from '../components/AuthHero';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const [installPrompt, setInstallPrompt] = useState(null);
  const [showInstall, setShowInstall] = useState(false);
  useEffect(() => {
    const handler = (e) => { e.preventDefault(); setInstallPrompt(e); setShowInstall(true); };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);
  const handleInstall = async () => {
    if (!installPrompt) return;
    installPrompt.prompt();
    const result = await installPrompt.userChoice;
    if (result.outcome === 'accepted') setShowInstall(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(form.email, form.password);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Login gagal');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="sh-auth" style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 20,
      background: 'transparent'
    }}>
      <AuthHero />
      <div className="sh-auth-card" style={{
        width: '100%',
        maxWidth: 400,
        background: '#FFFFFF', boxShadow: '0 4px 24px rgba(17,24,39,0.06)',
        border: '1px solid #E5E7EB',
        borderRadius: 16,
        padding: 32
      }}>
        <img src="/logo-full-v2.png" alt="Starhub Creative" style={{ height: 56, marginBottom: 24 }} />

        <h1 style={{ fontSize: 24, fontWeight: 700, color: '#111827', marginBottom: 4 }}>Selamat Datang</h1>
        <p style={{ fontSize: 14, color: '#6B7280', marginBottom: 28 }}>Login ke dashboard artis kamu</p>

        {/* 2026-10-12: setelah daftar, akun menunggu persetujuan admin */}
        {typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('registered') === 'true' && !error && (
          <div style={{ padding: '10px 12px', marginBottom: 14, borderRadius: 8, background: 'rgba(16,185,129,0.12)', color: '#059669', fontSize: 13, lineHeight: 1.5 }}>
            Pendaftaran diterima! Akun kamu sedang ditinjau admin. Kami akan mengirim email begitu akunnya aktif — setelah itu kamu bisa login.
          </div>
        )}
        {error && (
          <div style={{ background: 'rgba(239,68,68,0.16)', border: '1px solid #ef4444', color: '#ef4444', padding: '10px 14px', borderRadius: 8, fontSize: 14, marginBottom: 16 }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} autoComplete="on">
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#6B7280', marginBottom: 6 }}>Email</label>
            <input
              type="email"
              name="email"
              autoComplete="email"
              placeholder="email@kamu.com"
              value={form.email}
              onChange={e => setForm({ ...form, email: e.target.value })}
              required
              style={{ fontSize: 16 }}
            />
          </div>
          <div style={{ marginBottom: 8 }}>
            <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#6B7280', marginBottom: 6 }}>Password</label>
            <input
              type="password"
              name="password"
              autoComplete="current-password"
              placeholder="••••••••"
              value={form.password}
              onChange={e => setForm({ ...form, password: e.target.value })}
              required
              style={{ fontSize: 16 }}
            />
          </div>

          <div style={{ textAlign: 'right', marginBottom: 20 }}>
            <Link to="/forgot-password" style={{ color: '#FF5722', fontSize: 13, textDecoration: 'none' }}>
              Lupa password?
            </Link>
          </div>

          <button
            type="submit"
            className="btn btn-gold"
            style={{ width: '100%', padding: 14, fontSize: 16 }}
            disabled={loading}
          >
            {loading ? 'Loading...' : 'Login'}
          </button>
        </form>

        {showInstall && (
          <div onClick={handleInstall} style={{display:'flex',alignItems:'center',gap:10,marginTop:20,padding:'12px 16px',background:'rgba(255,87,34,0.08)',border:'1px solid rgba(255,87,34,0.25)',borderRadius:10,cursor:'pointer'}}>
            <span style={{fontSize:22}}>📲</span>
            <div>
              <div style={{fontSize:13,fontWeight:700,color:'#FF5722'}}>Install Starhub Creative App</div>
              <div style={{fontSize:11,color:'#6B7280',marginTop:2}}>Tambahkan ke layar utama untuk akses lebih cepat</div>
            </div>
          </div>
        )}
        <p style={{ textAlign: 'center', marginTop: 24, fontSize: 14, color: '#6B7280' }}>
          Belum punya akun? <Link to="/register" style={{ color: '#FF5722', textDecoration: 'none', fontWeight: 500 }}>Daftar sekarang</Link>
        </p>
      </div>
    </div>
  );
}
